import SocialProfilesList from './SocialProfilesList';

export default SocialProfilesList;
